import { Controller } from "@hotwired/stimulus";

import SlimSelect from "slim-select";

// Connects to data-controller="slim-select"
export default class extends Controller {
  static targets = ["select"];
  static values = {
    searchText: String,
    chooseText: String,
    noResultsText: String,
  };

  connect() {
    this.beforeStreamRender = this.beforeStreamRender.bind(this);
    document.addEventListener(
      "turbo:before-stream-render",
      this.beforeStreamRender,
    );
    this.init();
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-stream-render",
      this.beforeStreamRender,
    );
    this.teardown();
  }

  beforeStreamRender(event) {
    const target = document.getElementById(event.target.target);
    if (!target?.contains(this.element)) return;

    const render = event.detail.render;
    event.detail.render = async (stream) => {
      this.teardown();
      await render(stream);
      if (this.element.isConnected) this.init();
    };
  }

  init() {
    this.teardown();
    this.slim = new SlimSelect({
      select: this.selectTarget,
      settings: {
        placeholderText: this.chooseTextValue,
        searchPlaceholder: this.searchTextValue,
        searchText: this.noResultsTextValue,
      },
    });
  }

  teardown() {
    this.slim?.destroy();
    this.slim = null;
  }
}
